import { dynamicImage } from "../Service";
import { Nullable } from "../Types/Common";
import { female, femaleUserImg, male, maleUserImg, userImg } from "./Constant";

export const getUserImg = (
  userProfileImg: Nullable<string>,
  gender: Nullable<string>
) => {
  if (userProfileImg) return userProfileImg;

  if (gender === male) return dynamicImage(maleUserImg);
  if (gender === female) return dynamicImage(femaleUserImg);

  return dynamicImage(userImg);
};
